import imgDes0 from "../assets/media/klaseaDia3K42.mp4";
import imgDes1 from "../assets/media/klaseaDia1Barco1.mp4";
import imgDes2 from "../assets/media/klaseaDia1Barco2.mp4";
import imgDes3 from "../assets/media/klaseaDia1Barco3.mp4";
import imgDes4 from "../assets/media/klaseaDia1Barco4.mp4";
import imgDes5 from "../assets/media/klaseaDia1Barco5.mp4";
import imgDes6 from "../assets/media/klaseaDia1Barco6.mp4";
import imgDes7 from "../assets/media/klaseaDia2Barco1.mp4";
import imgDes8 from "../assets/media/klaseaDia2Barco2.mp4";
import imgDes9 from "../assets/media/klaseaDia2Barco3.mp4";
import imgDes10 from "../assets/media/klaseaDia2Barco4.mp4";
import imgDes11 from "../assets/media/klaseaDia3K62.mp4";
import imgDes12 from "../assets/media/klaseaDia3k2500.mp4";

import imgMob0 from "../assets/media/klaseaDia3K42Vert.mp4";
import imgMob1 from "../assets/media/klaseaDia1Barco1Vertical.mp4";
import imgMob2 from "../assets/media/klaseaDia1Barco2Vertical.mp4";
import imgMob3 from "../assets/media/klaseaDia1Barco3Vertical.mp4";
import imgMob4 from "../assets/media/klaseaDia1Barco4Vertical.mp4";
import imgMob5 from "../assets/media/klaseaDia1Barco5Vertical.mp4";
import imgMob6 from "../assets/media/klaseaDia1Barco6Vertical.mp4";
import imgMob7 from "../assets/media/klaseaDia1Barco1Vertical.mp4";
import imgMob8 from "../assets/media/klaseaDia1Barco2Vertical.mp4";
import imgMob9 from "../assets/media/klaseaDia1Barco3Vertical.mp4";
import imgMob10 from "../assets/media/klaseaDia1Barco4Vertical.mp4";
import imgMob11 from "../assets/media/klaseaDia3K62Vert.mp4";
import imgMob12 from "../assets/media/klaseaDia3k2500Vert.mp4";

const desVideos = [imgDes0, imgDes1, imgDes2, imgDes3, imgDes4, imgDes5, imgDes6, imgDes7, imgDes8, imgDes9, imgDes10, imgDes11, imgDes12];
const mobVideos = [imgMob0, imgMob1, imgMob2, imgMob3, imgMob4, imgMob5, imgMob6, imgMob7, imgMob8, imgMob9, imgMob10, imgMob11, imgMob12];

export { desVideos, mobVideos };

export function isMobile() {
    return window.innerWidth < 769;
}
